import { render, staticRenderFns } from "./group-list-header.vue?vue&type=template&id=171a3c9c"
import script from "./group-list-header.vue?vue&type=script&lang=js"
export * from "./group-list-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports